export enum InsertType {
    Range = "range",
    Table = "table",
    PivotTable = "pivotTable",
    Null = "null",
}
